import {
  GET_USER,
  GET_USERS_BY_ID,
  GET_USERS_BY_ID_SUCCESS,
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  START_FETCHING,
  ADD_USER,
  UPDATE_USER,
  GET_AUTHOR,
  GET_CRAFTSMAN,
  GET_AUTHOR_SUCCESS,
  GET_CRAFTSMAN_SUCCESS,
  ON_CHECKED_AUTHOR,
  ON_CHECKED_CRAFTSMAN,
  ADD_USER_ERROR,
  SET_CRAFTSMAN,
} from "./actionTypes"

export const addUsers = (data, toggle) => ({
  type: ADD_USER,
  data: data,
  toggle: toggle,
})
export const addUsersError = error => {
  return {
    type: ADD_USER_ERROR,
    payload: error,
  }
}

export const udpateUsers = (args, toggle) => ({
  type: UPDATE_USER,
  args: args,
  toggle: toggle,
})

export const getUsers = params => ({
  type: GET_USER,
  args: params,
})

export const getUsersById = id => ({
  type: GET_USERS_BY_ID,
  id: id,
})

export const getAuthor = () => ({
  type: GET_AUTHOR,
})

export const onCheckedAuthor = args => ({
  type: ON_CHECKED_AUTHOR,
  args: args,
})
export const onCheckedCraftsman = args => ({
  type: ON_CHECKED_CRAFTSMAN,
  args: args,
})

export const setCraftsman = args => ({
  type: SET_CRAFTSMAN,
  args: args,
})

export const getCraftsman = () => ({
  type: GET_CRAFTSMAN,
})

export const getAuthorSuccess = data => ({
  type: GET_AUTHOR_SUCCESS,
  payload: data,
})

export const getCraftsmanSuccess = data => ({
  type: GET_CRAFTSMAN_SUCCESS,
  payload: data,
})

export const getUserSuccess = data => ({
  type: GET_USER_SUCCESS,
  payload: data,
})
export const getUserByIdSuccess = data => ({
  type: GET_USERS_BY_ID_SUCCESS,
  payload: data,
})

export const getUSersFail = error => ({
  type: GET_USER_FAIL,
  payload: error,
})

export const startFetchUser = () => {
  return {
    type: START_FETCHING,
  }
}
